import { html, TemplateResult } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { HttpRequest } from './idb-graph-data-fetch-wrapper';
import componentStyles from './idb-graph-data.css.lit';
import '../idb-loading/idb-loading';
import '../idb-graphs-no-data/idb-graph-no-data';

export type GraphsTypes = 'projects' | 'country' | 'sector';

/**The IDB Graph Data component.
 * @element idb-graph-data
 */

@customElement('idb-graph-data')
export class IDBGraphData extends OutlineElement {
  static styles = [componentStyles];

  /**
   * Data coming from the API.
   */
  @property({ type: Object })
  dataList: object;

  /**
   * The type to know which graphic to load.
   */
  @property({ type: String, attribute: 'graph-type' })
  graphType: string;

  /**
   * Parameter to the request.
   */
  @property({ type: String, attribute: 'parameter' })
  parameter: string;

  /**
   * Lang to the request.
   */
  @property({ type: String, attribute: 'language' })
  language: string;

  /**
   * The title.
   */
  @property({ type: String, attribute: 'graphs-title' })
  graphsTitle: string;

  /**
   * The loans title.
   */
  @property({ type: String, attribute: 'loans-txt' })
  loansTxt: string;

  /**
   * The title.
   */
  @property({ type: String, attribute: 'graphs-sub-title' })
  graphsSubTitle: string;

  /**
   * Names for buttons.
   */
  @property({ type: Object, attribute: 'buttons' })
  buttons: string;

  /**
   * Names for radios.
   */
  @property({ type: Object, attribute: 'radios' })
  radios: string;

  /**
   * Names for tabs.
   */
  @property({ type: Object, attribute: 'tabs' })
  tabs: string;

  /**
   * Names for stat bar.
   */
  @property({ type: Object, attribute: 'stat-bar-label' })
  statBarLabel: string;

  /**
   * Template results.
   */
  content: TemplateResult<1>;

  connectedCallback() {
    super.connectedCallback();
    this.getData();
  }

  constructor() {
    super();
    this.content = html`<idb-loading>Loading</idb-loading>`;
    this.dataList = [];
  }

  render(): TemplateResult {
    return html`
      <div>
        ${this.content}
      </div>
    `;
  }

  selectController() {
    if (this.graphType == 'projects') {
      return html`
        <idb-graphs-projects
          graphs-title="${this.graphsTitle}"
          buttons=${JSON.stringify(this.buttons)}
          radios=${JSON.stringify(this.radios)}
          tabs=${JSON.stringify(this.tabs)}
          data-list=${JSON.stringify(this.dataList)}
          stat-bar-label=${JSON.stringify(this.statBarLabel)}
        >
        </idb-graphs-projects>`;
    } else if (this.graphType == 'country') {
      return html`
        <idb-graphs-countries
          graphs-title="${this.graphsTitle}"
          graphs-sub-title="${this.graphsSubTitle}"
          data-list=${JSON.stringify(this.dataList)}
        >
        </idb-graphs-countries>`;
    } else if (this.graphType == 'sector') {
      return html`
        <idb-graphs-sectors
          graphs-title="${this.graphsTitle}"
          loans-txt="${this.loansTxt}"
          buttons=${JSON.stringify(this.buttons)}
          radios=${JSON.stringify(this.radios)}
          tabs=${JSON.stringify(this.tabs)}
          data-list=${JSON.stringify(this.dataList)}
          stat-bar-label=${JSON.stringify(this.statBarLabel)}
        >
        </idb-graphs-sectors>`;
    }
    return html`<p>Send the graph-type parameter</p>`;
  }

  getData = async () => {


    // Set Data from the API.
    let PARAMETERS = `/${this.graphType}/${this.parameter}`;
    PARAMETERS = this.graphType == 'projects' ? '' : PARAMETERS;
    const BASE_URL = `${window.location.origin}/${this.language}/projects-json${PARAMETERS}`;

    const httpRequest = new HttpRequest();
    // Get Data from the API.
    const jsonData = await httpRequest.fetchJSON(BASE_URL);

    if (jsonData) {
      this.dataList = jsonData;
      this.content = this.selectController();
    } else {
      this.content = html`<idb-graph-no-data>
        <p slot="no-data-message">No data available</p>
      </idb-graph-no-data>`;
    }

    this.requestUpdate();
  };

  checkDomain() {
    const domain = window.location.hostname;
    const expression =
      /^(.*-idb-website\.pantheonsite\.io|.*-iadb\.devcloud\.fayze2\.com|iadb\.devcloud\.fayze2\.com|iadb\.docksal\.site|iadb\.org)$/;
    if (expression.test(domain)) {
      return false;
    } else {
      return true;
    }
  }
}
